import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-32 text-center">
      <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-medium mb-4">
        404
      </div>
      <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight text-slate-900">
        Page not found.
      </h1>
      <p className="text-slate-600 mt-5 text-base">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Button
        asChild
        className="mt-8 bg-blue-600 hover:bg-blue-700 text-white rounded-md h-11 px-6"
      >
        <Link to="/">Back to home</Link>
      </Button>
    </div>
  );
}
